<template>
  <div class="bookings">
    <page-header title="Shipments" breadcrumb="Dashboard > Bookings & Shipments > Shipments" />

    <div class="bg-white p-3">
      <div v-if="userAccountType != 'solo_operator'" class="flex justify-between mt-3 mb-3">
        <div :style="{ 'background-color': '#7B858F10' }" class="flex ">
          <button :class="{ active: currentMethod == 'terminal-to-terminal' }" class="tab-item"
            @click="currentMethod = 'terminal-to-terminal', showPage = 'shipments'">
            <p>Terminal-to-Terminal</p>
          </button>
          <button :class="{ active: currentMethod == 'terminal-to-door' }" class="tab-item"
            @click="currentMethod = 'terminal-to-door', showPage = 'shipments'">
            <p>Terminal-to-Door</p>
          </button>
          <button :class="{ active: currentMethod == 'door-to-door' }" class="tab-item"
            @click="currentMethod = 'door-to-door', showPage = 'shipments'">
            <!-- <p>Door-to-Door(inter-state)</p> -->
            <p>Door-to-Door</p>
          </button>
          <button hidden :class="{ active: currentMethod == 'door-to-door-within' }" class="tab-item"
            @click="currentMethod = 'door-to-door-within', showPage = 'shipments'">
            <p>Door-to-Door(intra-state)</p>
          </button>
          <button :class="{ active: showPage == 'requests' }" class="tab-item"
            @click="showPage = 'requests', currentMethod = ''">
            <p>Requests</p>
          </button>
        </div>

      </div>

      <div v-if="showPage == 'shipments'">
        <div class="flex justify-between mt-4 mb-3">
          <div :style="{ 'background-color': '#7B858F10' }" class="flex ">
            <button hidden :class="{ active: currentTab == 'draft' }" class="tab-item" @click="currentTab = 'draft'">
              <p>Draft</p>
            </button>
            <button :class="{ active: currentTab == 'pending' && showDispatch == false }" class="tab-item"
              @click="currentTab = 'pending', showDispatch = false">
              <p>Active Shipments</p>
            </button>
            <button v-if="userAccountType != 'solo_operator' && currentMethod !== 'door-to-door-within'"
              :class="{ active: currentTab == 'scheduled' }" class="tab-item" @click="currentTab = 'scheduled'">
              <p>Scheduled Shipments</p>
            </button>
            <button :class="{ active: currentTab == 'completed' }" class="tab-item"
              @click="currentTab = 'completed', showDispatch = false">
              <p>Completed Shipments</p>
            </button>
            <button v-if="userAccountType != 'solo_operator' && currentMethod !== 'door-to-door-within'"
              :class="{ active: currentTab == 'customer-bound' && showDispatch == true }" class="tab-item"
              @click="currentTab = 'customer-bound', showDispatch = true">
              <p>Customer-Bound Dispatch</p>
            </button>
          </div>

          <!-- <div class="flex justify-end">
              <button class="mr-4 px-5 py-2 rounded-md font-bold text-white pale-blue" @click="$router.push({ name : 'BookingRequests'})">All Requests</button>
          </div> -->
        </div>

        <div class="topline-wrapper px-2 py-2 ">
          <div class="topline px-3 flex flex-wrap justify-start">
            <div class="flex gap-2 topline-child">
              <CummulativeIcon />
              <p class="mt-2 font-bold">{{ showDispatch ? 'Dispatch' : 'Cummulative' }}</p>
            </div>

            <div class="topline-child">
              <p class="topline-header">SHIPMENTS (QTY)</p>
              <p class="topline-value">{{ shippingAnalytics.totalShipmentCount }}</p>
            </div>

            <div class="topline-child">
              <p class="topline-header">DISTANCE (M)</p>
              <p class="topline-value">{{ shippingAnalytics.totalShipmentDistance }}</p>
            </div>

            <div class="topline-child">
              <p class="topline-header">GROSS WEIGHT(KG)</p>
              <p class="topline-value">{{ shippingAnalytics.totalShipmentWeight }}</p>
            </div>

            <div class="topline-child">
              <p class="topline-header">REVENUE</p>
              <p class="topline-value">₦{{ shippingAnalytics.totalShipmentRevenue }}</p>
            </div>
          </div>

          <div v-if="!showDispatch" class="topline px-3 flex flex-nowrap justify-start">
            <div class="flex gap-2 topline-child">
              <TopChannelsIcon />
              <p class="mt-2 font-bold">Top Channels</p>
            </div>

            <div class="topline-child">
              <p class="topline-header">PLATFORM (QTY)</p>
              <p class="topline-value">{{ Number(shippingAnalytics.totalPlatform) }}</p>
            </div>

            <div v-if="userAccountType != 'solo_operator'" class="topline-child">
              <p class="topline-header">WALK-IN (QTY)</p>
              <p class="topline-value">{{ shippingAnalytics.totalWalkIn }}</p>
            </div>

            <div class="topline-child">
              <p class="topline-header">JUMIA (QTY)</p>
              <p class="topline-value">0</p>
            </div>

            <div class="topline-child">
              <p class="topline-header">CORNIE HEALTH (QTY)</p>
              <p class="topline-value">0</p>
            </div>

          </div>

          <div class="topline px-3 pb-2 flex flex-wrap justify-start">
            <div class="flex gap-2 topline-child">
              <TopRoutesIcon />
              <p class="mt-2 font-bold">Top {{ showDispatch ? 'Destinations' : 'Routes' }}</p>
            </div>

            <!-- When showDispatch = true -->
            <template v-if="showDispatch">
              <div class="topline-child" v-for="SS in shippingAnalytics.shippingServices" :key="SS.shippingServiceId">
                <p class="topline-header">{{ SS.routeName + ' (QTY)' }}</p>
                <p class="topline-value">{{ SS.totalAmountPaid }}</p>
              </div>
            </template>

            <!-- When showDispatch = false -->
            <template v-else>
              <div class="topline-child" v-for="(topRoute, index) in shippingAnalytics.topRoutes" :key="index">
                <p class="topline-header">{{ topRoute.routeName + ' (QTY)' }}</p>
                <p class="topline-value">{{ topRoute.totalShipments }}</p>
              </div>
            </template>

          </div>
        </div>

        <div class="group-options-select mb-4 mt-5">
          <div class="flex items-center justify-between">
            <div class="flex justify-start gap-4">
              <el-dropdown>
                <button class="sort-button flex items-center justify-center rounded-md h-full mr-3"
                  :class="{ 'shadow-sm': sortList }" style="width: 40px;height: 40px;background-color: #F7FAFD;">
                  <sort-icon />
                </button>
                <el-dropdown-menu slot="dropdown" placement="right-end">
                  <el-dropdown-item disabled>SORT BY</el-dropdown-item>

                  <el-dropdown-item>
                    <button @click="sortOrder = 'ASC'" class="flex items-center">
                      <span class="ml-2">ASC</span>
                    </button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <button @click="sortOrder = 'DESC'" class="flex items-center">
                      <span class="ml-2">DESC</span>
                    </button>
                  </el-dropdown-item>

                </el-dropdown-menu>
              </el-dropdown>

              <div v-if="!isIntrastateDoorToDoor" class="table__search-input-wrapper" style="width: 470px">
                <span class="pr-2 opacity-50">
                  <search-icon />
                </span>
                <input type="text" class="table__search-input" placeholder="Search..." v-model="queryString" />
                <img src="@/assets/images/icons/search.svg" alt="search icon" @click="showFilterModal = true"
                  class="cursor-pointer" />
              </div>


              <div v-else class="table__search-input-wrapper" style="width: 470px">
                <span class="pr-2 opacity-50">
                  <search-icon />
                </span>
                <input type="text" class="table__search-input" placeholder="Search..." v-model="queryString" />
                <img src="@/assets/images/icons/search.svg" alt="search icon" @click="setModal"
                  class="cursor-pointer" />
                <!-- <img src="@/assets/images/icons/search.svg" alt="search icon" @click="showFilterModal = true" class="cursor-pointer"/> -->
              </div>

            </div>

            <div class="date-picker flex items-center justify-center">
              <el-date-picker hidden type="date" placeholder="Start Date" style="margin: 0" class="mr-3"
                v-model="startDate" />

              <el-date-picker hidden type="date" placeholder="End Date" style="margin: 0" v-model="endDate" />

              <button v-if="currentMethod == 'terminal-to-terminal' && showDispatch == false"
                :style="{ height: '42px', opacity: selectedShipments.length == 0 ? 0.75 : 1 }"
                :disabled="selectedShipments.length == 0" :class="{ 'cursor-default': selectedShipments.length == 0 }"
                class="mr-4 px-5 rounded-md font-bold text-white pale-blue"
                @click="$router.push({ name: 'NewConsolidation', params: { preSelect: selectedShipments } })">Consolidate</button>

              <button v-if="currentMethod == 'terminal-to-door' && showDispatch == false"
                :style="{ height: '42px', opacity: selectedShipments.length == 0 ? 0.75 : 1 }"
                :disabled="selectedShipments.length == 0" :class="{ 'cursor-default': selectedShipments.length == 0 }"
                class="mr-4 px-5 rounded-md font-bold text-white pale-blue"
                @click="showDispatchDialog = true">Dispatch</button>

              <button v-if="showDispatch == true"
                :style="{ height: '42px', opacity: selectedShipments.length == 0 ? 0.75 : 1 }"
                :disabled="selectedShipments.length == 0" :class="{ 'cursor-default': selectedShipments.length == 0 }"
                class="mr-4 px-5 rounded-md font-bold text-white pale-blue"
                @click="showDispatchDialog = true">Dispatch</button>

              <base-button v-if="!showDispatch" @click="openModal" text="New Booking" />

              <base-button v-if="showDispatch" @click="openModal" text="Hand Off" />
            </div>
          </div>
        </div>

        <bookings-table :loading="loading" @booking-action-completed="refetchBookings" :bookings="bookings"
          :currentTab="currentTab" :currentMethod="currentMethod" @refetchBookings="refetchBookings"
          @newSelect="resetSelected($event)" v-if="!isIntrastateDoorToDoor" :resetCheckBox="resetCheckBox" />

        <BookingsTableDoorDoorIntraState v-else :loading="loading" @booking-action-completed="refetchBookings"
          :bookings="bookings" :currentTab="currentTab" :currentMethod="currentMethod"
          @refetchBookings="refetchBookings" @newSelect="resetSelected($event)" :pageSize="pageSize"
          :queryString="queryString" :pageNumber="pageNumber" :setTotalBooking="setTotalBooking" />



        <div class="mt-3">
          <pagination-control :total="totalBookings" :pageNumber="pageNumber" @pageSize="pageSize = $event"
            @pageNumber="pageNumber = $event" />
        </div>
      </div>

      <!-- <div v-if="selectedShipments.length > 0"> -->
      <div>
        <el-dialog :visible.sync="showDispatchDialog" width="40%">
          <h2 class="text-2xl font-semibold">Dispatch</h2>
          <div class="flex items-start justify-between mb-4">
            <div>
              <div>Dispatch ID: 457906-04</div>
            </div>
            <div>
              <div>
                <p>Item Count: <span>{{ selectedShipments.length }} (GW {{ totalShippmentWeight }}KG)</span></p>
              </div>
            </div>

          </div>

          <div>
            <div class="flex justify-between">
              <p>Customers({{ selectedShipments.length }})</p>
              <div @click="showItemsDiv = !showItemsDiv">
                <ArrowDownIcon class="cursor-pointer " />
                <ArrowUpIcon />
              </div>

            </div>
            <div v-if="showItemsDiv">

              <div v-for="item in selectedShipments" :key="item" class="mt-3">
                <p class="font-semibold">{{ shipmentDetails(item).consigneelocation.contactName }}</p>
                <div class="flex justify-between">
                  <p :style="{ 'color': '#383F5160' }" class="">{{ shipmentDetails(item).consigneelocation.mobile }}
                  </p>
                  <p :style="{ 'color': '#383F5160' }">{{ shipmentDetails(item).consigneelocation.address.name }}</p>
                  <p :style="{ 'color': '#383F5160' }">{{ shipmentDetails(item).packagees.length }} Items</p>
                </div>
              </div>
            </div>

            <div class="mt-3">
              <div>
                <label class="mb-1">Destination</label>
                <el-select v-model="destination" placeholder="" disabled>
                </el-select>
              </div>
            </div>

            <div class="mt-3">
              <div>
                <label class="mb-1">Driver/Dispatcher</label>

                <el-select v-model="driver" placeholder="Select Driver">
                  <el-option v-for="driver in drivers" :key="driver.id"
                    :label="driver.user.firstname + ' ' + driver.user.lastname + ' (' + driver.user.mobile_no + ')'"
                    :value="driver.id">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div hidden class="grid grid-cols-2 gap-x-3">

            <div>
              <label class="mb-1">Select Fleet</label>
              <!-- <el-select v-model="payload.fleetId" placeholder="Select fleet">
                <el-option
                  v-for="fleet in filterUndispatchedFleet"
                  :key="fleet.id"
                  :label="fleet.equipment"
                  :value="fleet.id"
                >
                </el-option>
              </el-select> -->
            </div>

            <div style="border: 1px solid #dae8f6; height: 200px">
              <div class="pl-4 flex items-center font-semibold" style="background: #ecf3fb; height: 60px">
                Origin
              </div>

              <div class="px-4 mt-4">

              </div>
            </div>

            <div class="mb-4" style="border: 1px solid #dae8f6; height: 200px">
              <div class="pl-4 flex items-center font-semibold" style="background: #cef1e8; height: 60px">
                Destination
              </div>

              <div class="px-4 mt-4">
                <label class="mb-1">Destination</label>
              </div>
            </div>


          </div>

          <div class="flex justify-end mt-5" style="height: 40px">

            <div class="h-full">
              <button class="h-full font-semibold" style="width: 120px" @click="showDispatchDialog = false">
                Cancel
              </button>

              <button @click="createTripsForBooking" :disabled="driver == ''"
                class="h-full bg-primary-yellow rounded font-semibold" style="width: 120px">
                Save
              </button>
            </div>
          </div>
        </el-dialog>
      </div>


      <div v-if="showPage == 'requests'">
        <BookingsRequest />
      </div>

      <TTsearchfilter @appliedRef="appliedReference" @filteredVal="filteredVal" :show-modal="showFilterModal"
        @close-modal="showFilterModal = false" :loading="loading" @booking-action-completed="refetchBookings"
        :bookings="bookings" :bookingData="bookingData" :currentTab="currentTab" :currentMethod="currentMethod"
        @refetchBookings="refetchBookings" @newSelect="resetSelected($event)" v-if="!isIntrastateDoorToDoor" />


      <!-- <DDsearchfilter v-if="showIntraStateModal" @close-modal="showIntraStateModal = false" :loading="loading" @booking-action-completed="refetchBookings" :bookings="bookings"
          :bookingData="bookingData" :currentTab="currentTab" :currentMethod="currentMethod"
          @refetchBookings="refetchBookings" @newSelect="resetSelected($event)" /> -->
      <booking-modal :show-modal="showModal" @close-modal="showModal = false" />
    </div>

  </div>
</template>

<script>
import moment from "moment";
import BookingModal from "./BookingSearchModal";
import BookingsTable from "./BookingsTable";
import BookingsTableDoorDoorIntraState from "./BookingsTableDoor_Door_IntraState.vue";
import PaginationControl from "@/components/UI/pagination";
import PageHeader from "@/components/UI/NewPageHeader";
import CummulativeIcon from "@/components/UI/svgs/CummulativeIcon.vue"
import TopChannelsIcon from "@/components/UI/svgs/TopChannelsIcon.vue"
import TopRoutesIcon from "@/components/UI/svgs/TopRoutesIcon.vue"
import BookingsRequest from "@/views/3pl/Operations/Requests/BookingRequests.vue"
import ArrowDownIcon from "@/components/UI/svgs/ArrowDownIcon.vue"
import debounce from "@/utilities/debounce";
import TTsearchfilter from "../Modals/TTsearchfilter.vue";
// import DDsearchfilter from "../Modals/TTsearchfilter.vue";

export default {
  components: {
    TTsearchfilter,
    // DDsearchfilter,
    PageHeader,
    BookingModal,
    BookingsTable,
    PaginationControl,
    CummulativeIcon,
    TopChannelsIcon,
    TopRoutesIcon,
    BookingsRequest,
    ArrowDownIcon,
    BookingsTableDoorDoorIntraState
  },
  data() {
    return {
      showFilterModal: false,
      // showIntraStateModal: false,
      loading: true,
      pageNumber: 1,
      pageSize: 10,
      totalBookings: 1,
      currentTab: "pending",
      currentMethod: 'terminal-to-terminal',
      sortList: false,
      startDate: null,
      // topRoutes: null,
      endDate: null,
      showModal: false,
      shipmentLayout: "table",
      isSelectShipmentLayout: false,
      bookings: {},
      queryString: null,
      requestLoading: false,
      estimate: 0.0,
      newEstimate: {
        takeoff: "",
        delivery: "",
        shipmentType: "package",
        length: 0,
        width: 0,
        height: 0,
        weight: 0,
        apiKey: "AIzaSyAys4Gc-dGXZmLn_zvNPMie_7d6oZicCuQ",
        quantity: 0,
      },
      sortOrder: "DESC",
      sortColumn: "",
      selectedShipments: [],
      showPage: 'shipments',
      showDispatch: false,
      showDispatchDialog: false,
      drivers: [],
      destination: "",
      driver: "",
      showItemsDiv: true,
      shippingAnalytics: {},
 
    };
  },
  computed: {
    isIntrastateDoorToDoor() {
      return this.currentMethod === "door-to-door-within"
    },
    locationId() {
      return this.$store.getters.currentLocationId;
    },
    userAccountType() {
      return this.$store.state.authentication.accountUserType;
    },
    totalShippmentWeight() {
      let selectShipping = []
      this.selectedShipments.forEach(async (element) => {
        let shipping = this.bookings.find((item) => item.shipping.id == element)
        selectShipping.push(shipping)
      });
      let val = (selectShipping || []).reduce((totalWeight, shipment) => {
        const packageWeight = (shipment?.shipping?.packagees || []).reduce((sum, pkg) => {
          return sum + Number(pkg.estimatedWeight || 0); // Parse weight and handle undefined/null values
        }, 0);

        return totalWeight + packageWeight;
      }, 0);
      return val;
    }
  },
  watch: {
    currentMethod() {
      this.getBookings({
        status: this.currentTab,
        terminalId: this.locationId,
        shippingMethod: this.currentMethod,
        startDate: this.startDate,
        endDate: this.endDate,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      });
    },
    currentTab: {
      handler() {
        this.pageNumber = 1;
        this.startDate = null;
        this.endDate = null;

        this.getBookings({
          status: this.currentTab,
          terminalId: this.locationId,
          shippingMethod: this.currentMethod,
          startDate: this.startDate,
          endDate: this.endDate,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        });
      },
      immediate: true,
    },

    sortOrder() {
      this.getBookings({
        status: this.currentTab,
        terminalId: this.locationId,
        shippingMethod: this.currentMethod,
        sortOrder: this.sortOrder,
        startDate:
          this.startDate != null
            ? moment(this.startDate).format("YYYY-MM-DD")
            : "",
        endDate:
          this.endDate != null ? moment(this.endDate).format("YYYY-MM-DD") : "",
        search: this.queryString,
        pageSize: this.pageSize,
        sortColumn: this.sortColumn,
      });
    },
    queryString: debounce(function () {
      this.getBookings({
        status: this.currentTab,
        terminalId: this.locationId,
        shippingMethod: this.currentMethod,
        sortOrder: this.sortOrder,
        startDate:
          this.startDate != null
            ? moment(this.startDate).format("YYYY-MM-DD")
            : "",
        endDate:
          this.endDate != null ? moment(this.endDate).format("YYYY-MM-DD") : "",
        search: this.queryString,
        pageSize: this.pageSize,
        sortColumn: this.sortColumn,
      });
    }, 500),
    locationId() {
      this.getBookings({
        status: this.currentTab,
        terminalId: this.locationId,
        shippingMethod: this.currentMethod,
        sortOrder: this.sortOrder,
        startDate:
          this.startDate != null
            ? moment(this.startDate).format("YYYY-MM-DD")
            : "",
        endDate:
          this.endDate != null ? moment(this.endDate).format("YYYY-MM-DD") : "",
        pageSize: this.pageSize,
        search: this.queryString,
        sortColumn: this.sortColumn,
      });
    },
    startDate() {
      if (this.startDate && this.endDate) {
        this.getBookings({
          status: this.currentTab,
          terminalId: this.locationId,
          shippingMethod: this.currentMethod,
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
          search: this.queryString,
          startDate: moment(this.startDate).format("YYYY-MM-DD"),
          endDate: moment(this.endDate).format("YYYY-MM-DD"),
        });
      }

      if (!this.startDate && !this.endDate) {
        this.getBookings({
          status: this.currentTab,
          terminalId: this.locationId,
          shippingMethod: this.currentMethod,
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
        });
      }
    },

    endDate() {
      if (this.startDate && this.endDate) {
        this.getBookings({
          status: this.currentTab,
          terminalId: this.locationId,
          shippingMethod: this.currentMethod,
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
          startDate: moment(this.startDate).format("YYYY-MM-DD"),
          endDate: moment(this.endDate).format("YYYY-MM-DD"),
        });
      }

      if (!this.startDate && !this.endDate) {
        this.getBookings({
          status: this.currentTab,
          terminalId: this.locationId,
          shippingMethod: this.currentMethod,
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
        });
      }
    },

    pageSize() {
      this.getBookings({
        status: this.currentTab,
        terminalId: this.locationId,
        shippingMethod: this.currentMethod,
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
        ...(this.startDate && {
          startDate: moment(this.startDate).format("YYYY-MM-DD"),
        }),
        ...(this.endDate && {
          endDate: moment(this.startDate).format("YYYY-MM-DD"),
        }),
      });
    },

    pageNumber() {
      this.getBookings({
        status: this.currentTab,
        terminalId: this.locationId,
        shippingMethod: this.currentMethod,
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
        ...(this.startDate && {
          startDate: moment(this.startDate).format("YYYY-MM-DD"),
        }),
        ...(this.endDate && {
          endDate: moment(this.startDate).format("YYYY-MM-DD"),
        }),
      });
    },

    shipmentLayout() {
      this.isSelectShipmentLayout = false;
    },
    selectedShipments(val) {
      if (val.length > 0 && this.showDispatch) {
        // this.showDispatchDialog = true
      } else {
        this.showDispatchDialog = false
      }
    }
  },
  mounted() {
    this.getLocationsManaged();
    this.gettingAllLocations();
    if (this.$route.query.consolidationId) {
      this.showModal = false;
    }

    if (this.$route.query.currentTab) {
      this.currentTab = this.$route.query.currentTab;
    }

    this.getAnalytics();
    
    this.getDriver();
  },
  methods: {
    getTopRouteQty(route) {
      if (!Array.isArray(route?.topRoutes)) return 0
      return route?.topRoutes?.map((item) => Number(item.totalShipments)).reduce((item, sum) => sum + item, 0)
    },
    getTopRouteDistance(route) {
      if (!Array.isArray(route?.topRoutes)) return 0
      return route?.topRoutes?.map((item) => Number(item.totalDistance)).reduce((item, sum) => sum + item, 0)
    },
    getTopRouteGrossWgt(route) {
      if (!Array.isArray(route?.topRoutes)) return 0
      return route?.topRoutes?.map((item) => Number(item.totalGrossWeight)).reduce((item, sum) => sum + item, 0)
    },
    getTopRouteRevenue(route) {
      if (!Array.isArray(route?.topRoutes)) return 0
      const totalRevenue = route?.topRoutes?.map((item) => Number(item.totalRevenue)).reduce((item, sum) => sum + item, 0)
       return totalRevenue.toLocaleString('en-US', {
        minimumFractionDigits: 2,  // Ensure 2 decimal places
        maximumFractionDigits: 2   // Optional: Ensures no more than 2 decimal places
      })
    },
    setModal() {
      this.showIntraStateModal = true
    },
    appliedReference(filteredVal) {
      this.queryString = filteredVal
    },
    filteredVal(val) {
      this.channels = val
      this.getFilteredBookings()
    },
    setTotalBooking(val) {
      this.totalBookings = val
    },
    resetSelected(selected) {
      this.selectedShipments = selected
      this.destination = this.shipmentDetails(selected[0]).consigneelocation.address.locality
    },
    openModal() {
      this.showModal = true;
    },
    refetchBookings() {
      this.loading = true;
      this.getBookings({
        status: this.currentTab,
        shippingMethod: this.currentMethod,
        terminalId: this.locationId,
        startDate: this.startDate,
        endDate: this.endDate,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      });
    },
    shipmentDetails(id) {
      if (this.bookings.length > 0) {
        return this.bookings.find(x => x.shipping.id == id)?.shipping
      }

    },
    async getLocationsManaged() {
      try {
        this.loading = true;
        const response = await this.$_getLocationsManaged();
        this.$store.dispatch("saveManagedLocations", response.data.data);
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
    getTakeOff(addressData) {
      this.newEstimate.takeoff = addressData.route;
    },
    getDelivery(addressData) {
      this.newEstimate.delivery = addressData.route;
    },
    disabled() {
      return this.$store.state.authentication.env == "staging" ? true : false;
    },
    gettingAllLocations() {
      try {
        this.$_getAllLocations().then((response) => {
          this.$store.dispatch(
            "saveOrgLocations",
            response.data.data.locations
          );
        });
      } catch (error) {
        this.handleError(error);
      }
    },

    async getBookings(data) {
      try {
        this.loading = true;

        if (this.locationId) {
          const { data: response } = await this.$_getBookingsByTerminal(this.locationId, data);
          this.bookings = response.data.terminalShippings;
          this.totalBookings = response.data.totalCount;
        }

      } catch (error) {
        if (this.locationId) {
          this.handleError(error);
        }
      } finally {
        this.loading = false;
      }
    },

    async getAnalytics() {
      try {
        this.loading = true;
        const { data: response } = await this.$_getBookingToplineAnalytics();
        this.shippingAnalytics = response.data
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },

    // async getTopRoutes() {
    //   try {
    //     this.loading = true;
    //     const { data: response } = await this.$_getShippingTopRoutes();
    //     this.topRoutes = response.data.topRoutes
    //   } catch (error) {
    //     this.handleError(error);
    //   } finally {
    //     this.loading = false;
    //   }
    // },

    async getDriver() {
      try {
        const { data: response } = await this.$_getOutboundDispatcher();
        this.drivers = response.data
      } catch (error) {
        this.handleError(error);
      }
    },

  },
};
</script>
<style lang="scss" scoped>
.el-date-editor.el-input {
  margin-bottom: 0;
}

.tab-item {
  cursor: pointer;
  // margin-right: 1rem;
  color: #10233e6e;
  padding: 0.25rem 1.5rem;
  font-size: 0.9rem;

  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #fcc210;
    font-weight: bold;
  }
}
</style>

<style lang="scss" scoped>
.estimate-form-wrapper {
  padding: 1rem;
  background: #ffffff;
  /* cards */

  box-shadow: 0px 20px 40px #edf0f5;
  border-radius: 5px;
}

.topline-wrapper {
  border: 1px solid gray;
  border-style: dashed;
  border-radius: 5px;
  margin-top: 30px;
  box-shadow: 10px 10px 30px rgb(227, 224, 224);

  .topline {
    background-color: #F2F7FC;
    border-radius: 10px;
    margin-top: 7px;
    height: 72px;
    padding-top: 16px;
    vertical-align: middle;

    .topline-child {
      border-right: 1px dashed #4142455C;
      height: 40px;
      padding: 0px 20px 0px 20px;
      width: 20%;

      .topline-header {
        color: #7A90A7;
        font-weight: 600;
        font-size: 14px;
      }

      .topline-value {
        color: #10233E;
        font-weight: 600;
        font-size: 16px;
      }
    }
  }
}


.header p {
  color: #1f1f1f;
  font-size: 1.35rem;
  padding: 1rem 0.5rem;
  font-weight: 500;
}

.estimate-form {
  display: flex;
  flex-wrap: wrap;
}

.input-wrapper,
.calculate-button {
  width: 50%;
  padding: 0 0.5rem;

  .input {
    background: #fbfcfe;
    border: 1px solid #dae8f6;
    box-sizing: border-box;
    border-radius: 2px;
  }

  div {
    width: 50%;
  }
}

.shipment-type-select {
  width: 50%;
  padding: 0 0.5rem;
}

.vehicle-types {
  display: flex;
}

.vehicle-type {
  background: #fbfcfe;
  border: 1px solid #dae8f6;
  box-sizing: border-box;
  border-radius: 2px;
  padding: 0.5rem 0;
  margin-right: 0.5rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 5rem;

  small {
    color: #7a91a7;
    padding-top: 0.5rem;
    font-size: 0.7rem;
  }
}

.button {
  background: #fcc210;
  color: var(--primaryblue);
  width: 100%;
  margin-top: 3rem;
}

.shipment-action {
  height: 50%;
  border-radius: 10px;
  color: #ffffff;
  padding: 3.72rem 1rem;
}

.book-shipment-button {
  background: #0f9cda;
  margin-bottom: 1rem;
  background-image: url("../../../../../assets/images/booking-management/book-shipment-bg.png");
  background-repeat: no-repeat;
  background-position: center right;
  background-size: contain;
}

.scheduled-shipments-button {
  background: #00c49a;
  background-image: url("../../../../../assets/images/booking-management/scheduled-shipment-bg.png");
  background-repeat: no-repeat;
  background-position: center right;
  background-size: contain;
}

.estimate-result {
  width: 13.5rem;
  height: 2.75rem;
  background: linear-gradient(180deg,
      #e2ebfa 11.98%,
      rgba(226, 235, 250, 0) 51.56%,
      #e2ebfa 95.83%);
  border: 2px solid #2d9cdb;
  border-radius: 5px;
  display: flex;
  align-items: center;
  margin-right: 0.5rem;

  span {
    color: #cad7f2;
    font-size: 1.3rem;
    padding-left: 0.5rem;
    font-weight: 500;
  }
}

.shipment-layout-select {
  right: 5.5rem;
  top: 1.5rem;
  z-index: 999;
  position: absolute;
  background: #ffffff;
  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 10px;
  padding: 0.75rem;
  width: 10rem;
}

.label {
  font-size: 0.7rem;
}

.shipment-layout-select .selected {
  color: #e59506;
}

.dimension-input {
  width: 4rem;
}

.dimension-input-wrapper {
  width: 100% !important;
}

.pale-blue {
  background-color: #10233e;
}
</style>
